module.exports = __webpack_public_path__ + "static/completed-tasks-c1e4f87b61430dc2c7fc3cfe883349bf.svg";